import { makeStyles } from "@material-ui/core/styles";

export const useUnsavedChangesModalStyles = makeStyles(() => ({
  message: {
    "text-align": "center",
    whiteSpace: "pre-line",
  },
}));
